<template>
  <div>
    <b-tabs content-class="mt-3">
      <b-tab title="General Information" active>
        <b-form>
          <b-row v-if="editStatus">
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Customer Identifier</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="customerIdentifier"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Group Permissions</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group label-for="input-1">
                <b-form-select
                  id="period"
                  v-model="generalInformationForm.customerGroup"
                  :options="groupOption"
                  :state="customerGroupStatus"
                  value-field="key"
                  class="mt-2"
                  text-field="label"
                ></b-form-select>
                <b-form-invalid-feedback :state="customerGroupStatus">
                  Please select a valid group.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Company Name</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="companyNameStatus"
                  v-model="generalInformationForm.companyName"
                ></b-form-input>
                <b-form-invalid-feedback :state="companyNameStatus">
                  Please enter a valid company name.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Address 1</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="address1Status"
                  v-model="generalInformationForm.address1"
                ></b-form-input>
                <b-form-invalid-feedback :state="address1Status">
                  Please enter valid address 1.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Address 2</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="true"
                  v-model="generalInformationForm.address2"
                ></b-form-input>
                <b-form-invalid-feedback :state="true">
                  Please enter a valid address 2.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">City</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="cityStatus"
                  v-model="generalInformationForm.city"
                ></b-form-input>
                <b-form-invalid-feedback :state="cityStatus">
                  Please enter a valid city.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">State</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="stateStatus"
                  v-model="generalInformationForm.state"
                ></b-form-input>
                <b-form-invalid-feedback :state="stateStatus">
                  Please enter a valid state.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Country</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="countryStatus"
                  v-model="generalInformationForm.country"
                ></b-form-input>
                <b-form-invalid-feedback :state="countryStatus">
                  Please enter a valid country.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Zip Code</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  type="number"
                  :state="zipCodeStatus"
                  v-model="generalInformationForm.zipCode"
                ></b-form-input>
                <b-form-invalid-feedback :state="zipCodeStatus">
                  Please enter a valid zip code.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Contact Person</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="contactPersonStatus"
                  v-model="generalInformationForm.contactPerson"
                ></b-form-input>
                <b-form-invalid-feedback :state="contactPersonStatus">
                  Please enter a valid contact person.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Phone No</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
                class="country-code"
              >
                <vue-tel-input
                  v-model="generalInformationForm.phoneNo"
                  placeholder="201-555-2123"
                  :defaultCountry="preferredCountry"
                  :enabledCountryCode="enabledCountryCodeStatus"
                  :state="phoneNoStatus"
                  :validCharactersOnly="validCharactersOnly"
                  @country-changed="onSelect"
                ></vue-tel-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="3" lg="3" sm="3">
              <p class="mt-3">
                <span class="h3">Email</span>
              </p>
            </b-col>
            <b-col xl="9" lg="9" sm="9">
              <b-form-group
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  :state="emailStatus"
                  v-model="generalInformationForm.email"
                ></b-form-input>
                <b-form-invalid-feedback :state="emailStatus">
                  Please enter a valid email.
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <div class="mt-3 d-flex justify-content-between">
            <base-button type="white" title="Close"  v-on:click="modalClose()">
              Close
            </base-button>
            <base-button type="primary" title="Submit"  :loading="submitLoading" v-on:click="generalInformationSubmit" >
              Submit
            </base-button>
          </div>
        </b-form>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import administratorService from "../../common/api-services/administrator-service";
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: "Customer-Create",
  components: {
    VueTelInput
  },
  computed: {
    customerGroupStatus() {
      return this.generalInformationForm.customerGroup !== 'Select Group';
    },
    companyNameStatus() {
      return this.generalInformationForm.companyName.length > 0
    },
    address1Status() {
      return this.generalInformationForm.address1.length > 0
    },
    cityStatus() {
      return this.generalInformationForm.city.length > 0
    },
    stateStatus() {
      return this.generalInformationForm.state.length > 0
    },
    countryStatus() {
      return this.generalInformationForm.country.length > 0
    },
    zipCodeStatus() {
      return this.generalInformationForm.zipCode.length > 0
    },
    contactPersonStatus() {
      return this.generalInformationForm.contactPerson.length > 0
    },
    phoneNoStatus() {
      return this.generalInformationForm.phoneNo.trim()
    },
    emailStatus() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.generalInformationForm.email).toLowerCase())
    },
    usernameStatus() {
      return this.userInformationForm.username.length > 0
    },
    passwordStatus() {
      return !!(this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
    },
    passwordLength() {
      return this.userInformationForm.password.length > 7
    },
    passwordUppercase() {
      let pass = this.userInformationForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('A' <= pass[i] && pass[i] <= 'Z') {
          return true;
        }
      }
    },
    passwordNumber() {
      let pass = this.userInformationForm.password;
      for (let i = 0; i < pass.length; i++) {
        if ('0' <= pass[i] && pass[i] <= '9') {
          return true;
        }
      }
    },
    passwordCharacter() {
      let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
      if (format.test(this.userInformationForm.password)) {
        return true
      }
    }
  },
  data() {
    return {
      generalInformationForm: {
        customerGroup: 'Select Group',
        companyName: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
        contactPerson: '',
        phoneNo: '',
        email: ''
      },
      userInformationForm: {
        username: '',
        password: ''
      },
      groupOption: [],
      enabledCountryCodeStatus: true,
      dialCode: '',
      customerIdentifier: '',
      editStatus: false,
      preferredCountry: 'us',
      validCharactersOnly: true,
      submitLoading: false
    }
  },
  mounted() {
    this.getSelectGroup();

    this.$root.$on('editCustomerInfo', (res => {
      this.inputFormValue(res)
    }))
  },
  methods: {
    onSelect({name, iso2, dialCode}) {
      this.dialCode = dialCode
    },

    generalInformationSubmit(event) {
      event.preventDefault();
      if (this.customerGroupStatus && this.companyNameStatus && this.address1Status && this.cityStatus &&
        this.stateStatus && this.countryStatus && this.zipCodeStatus && this.phoneNoStatus && this.emailStatus) {
        this.submitLoading = true;

        if (this.editStatus) {
          this.updateCustomerInfoFunc()
        } else {
          this.addCustomerInfoFunc();
        }
      } else {
        this.$toast.error("Please check validation")
      }
    },

    addCustomerInfoFunc() {
      this.generalInformationForm.phoneNo = this.dialCode + this.generalInformationForm.phoneNo.replace('(', '').replace(')', '').trim();
      administratorService.addCustomer(this.generalInformationForm).then(res => {
        this.modalClose();
        this.$toast.success(res)
        this.$root.$emit('getCustomerInfo')
      })
    },

    getSelectGroup() {
      administratorService.getGroupList().then(res => {
        this.groupOption.push({
          key: 'Select Group',
          label: 'Select Group'
        });
        res.map((item, index) => {
          let child = {
            key: item.GroupName,
            label: item.GroupName
          };
          this.groupOption.push(child)
        })
      })
    },


    modalClose() {
      this.$bvModal.hide('customer-create');
    },

    userInformationSubmit() {
      if (this.usernameStatus && this.passwordStatus) {
        if (this.phoneNoStatus) {
          if (this.emailStatus) {
            if (this.customerGroupStatus) {
              this.generalInformationForm.phoneNo = this.dialCode + this.generalInformationForm.phoneNo;
              let data = btoa(
                this.userInformationForm.username + '|' + this.generalInformationForm.email + '|' +
                this.generalInformationForm.phoneNo + '|' + this.userInformationForm.password
              );
              administratorService.registerUser(data).then(res => {
                //console.log(res)
              });
              this.addCustomerInfoFunc();
            } else {
              this.$toast.error('Please input valid customer group')
              return false;
            }
          } else {
            this.$toast.error('Please input valid email')
            return false;
          }
        } else {
          this.$toast.error('Please input valid phone number')
          return false;
        }
      } else {
        this.$toast.error('Please check validation')
        return false;
      }
    },

    updateCustomerInfoFunc() {
      this.generalInformationForm.phoneNo = this.dialCode + this.generalInformationForm.phoneNo.replace('(', '').replace(')', '').trim();
      administratorService.updateCustomer(this.customerIdentifier, this.generalInformationForm).then(res => {
        this.modalClose();
        this.$root.$emit('showNotification', {type: 'success', msg: res});
        this.$root.$emit('getCustomerInfo')
      })
    },

    inputFormValue(res) {
      this.editStatus = true;
      this.customerIdentifier = res.customer_id;
      this.generalInformationForm.customerGroup = res.customer_group;
      this.generalInformationForm.companyName = res.company_name;
      this.generalInformationForm.address1 = res.address1;
      this.generalInformationForm.address2 = res.address2;
      this.generalInformationForm.city = res.city;
      this.generalInformationForm.state = res.state;
      this.generalInformationForm.country = res.country;
      this.generalInformationForm.zipCode = res.zipcode;
      this.generalInformationForm.contactPerson = res.contact_name;
      this.generalInformationForm.phoneNo = res.contact_phone;
      this.generalInformationForm.email = res.contact_email;
    }
  }
}
</script>
